import { EventPageType } from '@graphql/generated-base';

// Null/undefined means "unknown" — e.g. older cached responses or BE upstream failure.
// Fail-open so RSVP entry points stay visible until we have positive proof.
export const isRsvpEffectivelyEnabled = (rawRsvpIsEnabled: Maybe<boolean> | undefined, hasEnabledLegacyRsvpQuestions: Maybe<boolean> | undefined): boolean => {
  if (!rawRsvpIsEnabled) {
    return false;
  }
  return hasEnabledLegacyRsvpQuestions !== false;
};

export const filterRsvpPageIfEffectivelyDisabled = <P extends Readonly<{ type: EventPageType }>>(
  pages: ReadonlyArray<P>,
  hasEnabledLegacyRsvpQuestions: Maybe<boolean> | undefined,
): ReadonlyArray<P> => {
  if (hasEnabledLegacyRsvpQuestions !== false) {
    return pages;
  }
  return pages.filter(page => page.type !== EventPageType.rsvp);
};
